import { render, staticRenderFns } from "./CerrarExpedienteDialog.vue?vue&type=template&id=343086e2&"
import script from "./CerrarExpedienteDialog.vue?vue&type=script&lang=js&"
export * from "./CerrarExpedienteDialog.vue?vue&type=script&lang=js&"
import style0 from "./CerrarExpedienteDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VDialog,
  VFlex,
  VLayout,
})
